<template>
    <div>

        <div v-show="indicators.length > 0">
            <h2>Used Sources</h2>

            <ul class="my-4 list-reset bg-white shadow">
                <li v-for="item in indicators" class="border-b">
                    <a class="cursor-pointer px-2 lg:px-8 hover:bg-blue-lighter py-4 text-black no-underline block flex"
                       @click="$emit('database', item.indicator.name)">
                        <i class="fa fa-fw fa-database text-blue-dark"></i>
                        {{ item.indicator.translations.en }}
                    </a>
                </li>
            </ul>
        </div>

        <div v-show="list.length > 0">
            <h2 class="mt-4">Series</h2>

            <ul class="my-4 list-reset bg-white shadow">
                <li v-for="item in list" class="border-b pl-8 py-4 flex justify-between">
                    <p>{{ item.description.en }}</p>
                    <span>
                    <a @click="remove(item)" class="cursor-pointer hover:text-red  p-4">
                        <i class="fa fa-times"></i>
                    </a>
                </span>
                </li>
            </ul>
        </div>

        <div v-show="list.length === 0" class="my-8">
            <p>0 Series selected.</p>

            <p>Add Series to your collection</p>
        </div>

    </div>
</template>

<script>
    export default {
        name: "LibrarySeries",

        inject: ['report'],

        computed: {
            indicators() {
                return this.$store.getters.indicators;
            },
            list() {
                return this.report.selected;
            },
        },

        methods: {
            remove: function (remove) {
                this.report.selected = this.report.selected.filter(function (item) {
                    return item !== remove;
                });
            },
        }

    }
</script>

<style scoped>

</style>
